<template>
  <closable-list-item
    :is-visible="showTerminalNotification && !isHiddenTerminalUseNotification"
    path-name="terminalsList"
    @close="hideTerminalUseNotification"
  >
    <template #content>
      <div class="shrink-0 bg-threshold-tints-600 rounded-full h-12 w-12 flex items-center justify-center text-black">
        <wui-icon
          name="callMade"
          large
        />
      </div>
      <span class="text-1316 text-wrap max-w-[264px]">
        {{ $t('common.outgoingCallsUseTerminal') }} {{ defaultTerminalLabel }}
      </span>
    </template>
  </closable-list-item>
</template>

<script lang="ts" setup>
import { WuiIcon } from '@wui/common-library'
import { storeToRefs } from 'pinia'

import { isHiddenTerminalUseNotification, hideTerminalUseNotification, useStoreSettingsTerminals } from '@/entities/user-terminal'

import { ClosableListItem } from '@/shared/components/closable-list-item'

const { defaultTerminalLabel, showTerminalNotification } = storeToRefs(useStoreSettingsTerminals())
</script>
